import { NavLink } from 'react-router-dom';
import { Home, BarChart3, Gift, CreditCard, FileText, Settings } from 'lucide-react';
import { cn } from '../../lib/utils';

const navItems = [
  { name: 'Home', path: '/', icon: Home },
  { name: 'Insights', path: '/insights', icon: BarChart3 },
  { name: 'Gamification', path: '/gamification', icon: Gift },
  { name: 'Applications', path: '/applications', icon: FileText },
  { name: 'Payments', path: '/payments', icon: CreditCard },
];

const Sidebar = () => {
  return (
    <div className="w-64 bg-gradient-to-b from-purple-50 to-white border-r border-purple-100 flex flex-col h-screen">
      {/* Logo */}
      <div className="p-6">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
            <Gift className="w-5 h-5 text-white" />
          </div>
          <span className="text-xl font-bold text-primary">
            Saral
          </span>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200",
                isActive
                  ? "bg-purple-100 text-primary"
                  : "text-gray-600 hover:bg-purple-50 hover:text-primary"
              )
            }
          >
            <item.icon className="w-5 h-5" />
            <span className="font-medium">{item.name}</span>
          </NavLink>
        ))}
      </nav>

      {/* Settings */}
      <div className="p-3 border-t border-purple-100">
        <NavLink
          to="/settings"
          className={({ isActive }) =>
            cn(
              "flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200",
              isActive
                ? "bg-purple-100 text-primary"
                : "text-gray-600 hover:bg-purple-50 hover:text-primary"
            )
          }
        >
          <Settings className="w-5 h-5" />
          <span className="font-medium">Settings</span>
        </NavLink>
      </div>
    </div>
  );
};

export default Sidebar;
